import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { View } from 'foundations-components/transitional/components/View';
import { filterProps } from 'foundations-components/utils/filterProps';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
function WidgetPlaceholderContainer(_ref) {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(View, Object.assign({
    paddingBlock: "200",
    paddingInline: "400",
    borderStyle: "dashed",
    borderWidth: "100",
    borderColor: "icon-tertiary-default",
    backgroundColor: "fill-tertiary-hover",
    borderRadius: "200",
    margin: "50"
  }, tokenProps, {
    children: /*#__PURE__*/_jsx(NamespaceWrapper, {
      children: /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
        children: children
      }))
    })
  }));
}
export default WidgetPlaceholderContainer;